import { Box, Theme } from '@mui/material'
import { styled } from '@mui/material/styles'

interface HorizontalNavContainerProps {
  isloading?: boolean
  pinned?: boolean
}

export const HorizontalNavContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isloading' && prop !== 'pinned',
})<HorizontalNavContainerProps>(
  ({ theme, isloading, pinned }: { theme: Theme; isloading?: boolean; pinned?: boolean }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: !isloading && pinned ? theme.palette.background.default : 'transparent',
    transition: 'filter 0.3s ease',
    width: '100%',
    backdropFilter: pinned ? 'blur(4px)' : 'blur(4px)',
  })
)
